import { ChevronDown, ChevronRight } from "lucide-react"
import moment from "moment"

export const HeadRows = ({ openAll, setOpenAll, months }) => {
    return (
        <>

            {months.length > 0 && <tr>
                <th colSpan={5} className=""></th>
                <th colSpan={months?.length} style={{ backgroundColor: '#FCF1FF' }} className="bg-[#FCF1FF] p-0">
                    <div className="w-full text-center text-[#8E24AA] py-2 px-4">
                        COBROS PROYECTADOS
                    </div>
                </th>
            </tr >}

            <tr style={{ verticalAlign: 'middle', textTransform: 'uppercase', color: '#8E24AA' }}>
                <th
                    className="min-w-60 text-start cursor-pointer sticky left-[-25px] top-0 z-50 bg-white"
                    onClick={() => setOpenAll(!openAll)}
                >
                    <div className="d-flex justify-content-start">
                        <span>
                            {!openAll ?
                                <ChevronRight
                                    className="h-4 w-4 text-muted-foreground shrink-0 pointer"
                                />
                                :
                                <ChevronDown
                                    className="h-4 w-4 text-muted-foreground shrink-0 pointer"
                                />
                            }
                        </span>
                        <span className="ms-2">Cliente / Proyecto</span>
                    </div>
                </th>
                <th className="min-w-24 sticky top-0 z-40 bg-white">Proyectado</th>
                <th className="min-w-24 sticky top-0 z-40 bg-white">Cobrado</th>
                <th className="min-w-24 sticky top-0 z-40 bg-white">Por cobrar</th>
                <th className="min-w-24 sticky top-0 z-40 bg-white" style={{ color: 'red' }}>Vencido</th>
                {months.map((month, index) => (
                    <th key={index} className="min-w-24 sticky top-0 z-40 bg-white">
                        {moment(month).format('MMM') + ' ' + moment(month).format('YY')}
                    </th>
                ))}
            </tr>
        </>
    )
}